import { useContext, useEffect, useState, useCallback } from 'react'
import { useGetTrainingTopicsQuery, useToggleTrainingActivationMutation } from '../api/trainingTopics'
import { SettingsContext } from 'src/App'

export const useTrainingTopics = () => {
  const [{ companyLanguage }] = useContext(SettingsContext)
  const [language, setLanguage] = useState(companyLanguage)
  const [filteredTrainings, setFilteredTrainings] = useState(null)
  const [topicType, setTopicType] = useState('CUSTOM')
  const [searchQuery, setSearchQuery] = useState('')
  const [initialCount, setInitialCount] = useState(null)

  const {
    data: trainings,
    isLoading,
    isFetching,
    isError,
    refetch
  } = useGetTrainingTopicsQuery({
    language,
    type: topicType,
    searchText: searchQuery
  })

  const [toggleActivation] = useToggleTrainingActivationMutation()

  useEffect(() => {
    setInitialCount(trainings?.length || 0)
  }, [])

  useEffect(() => {
    setLanguage(companyLanguage)
  }, [companyLanguage])

  useEffect(() => {
    if (!isLoading && trainings) {
      setFilteredTrainings(trainings)
    }
  }, [trainings, isLoading])

  const handleActivateTraining = async (id, active) => {
    await toggleActivation({ id, active })
  }

  const handleLanguageChange = newLanguage => {
    setLanguage(newLanguage)
  }

  const fetchTopics = useCallback(
    (type, search) => {
      setTopicType(type)
      setSearchQuery(search)
      refetch({ force: true })
    },
    [refetch]
  )

  return {
    trainings: filteredTrainings,
    initialCount,
    isLoading,
    isFetching,
    isError,
    language,
    handleActivateTraining,
    handleLanguageChange,
    fetchTopics
  }
}
